
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import EnergyConsumption from './EnergyConsumption';
import HvacRuntime from './HvacRuntime';
import EnergyCost from './EnergyCost';
import ChillerEfficiency from './ChillerEfficiency';
import CompactLayout from '@/components/layout/CompactLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Hammer } from 'lucide-react';

/**
 * This component routes to the appropriate KPI detail page based on the ID parameter
 */
const KpiDetailRouter: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  // Map KPI IDs to their respective components for those that are implemented
  switch (id) {
    case 'energy-consumption':
      return <EnergyConsumption />;
    case 'hvac-runtime':
      return <HvacRuntime />;
    case 'energy-cost':
      return <EnergyCost />;
    case 'chiller-efficiency':
      return <ChillerEfficiency />;
    default:
      // For all other KPIs, show a friendly "Under Development" message
      return (
        <CompactLayout>
          <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-[calc(100vh-4rem)] flex items-center justify-center">
            <Card className="max-w-md">
              <CardContent className="p-6 text-center">
                <Hammer className="h-12 w-12 mx-auto text-amber-500 mb-4" />
                <h2 className="text-xl font-semibold mb-2">KPI Detail Under Development</h2>
                <p className="text-gray-600 dark:text-gray-400 mb-4">
                  The KPI detail page for "{id}" is currently under development.
                </p>
                <p className="text-gray-600 dark:text-gray-400 mb-4 text-sm">
                  Try one of the completed KPI pages instead: Energy Consumption, HVAC Runtime, Energy Cost, or Chiller Efficiency.
                </p>
                <div className="mt-4">
                  <Navigate to="/energy/top-kpis" replace />
                </div>
              </CardContent>
            </Card>
          </div>
        </CompactLayout>
      );
  }
};

export default KpiDetailRouter;
